// extracted by mini-css-extract-plugin
export default {"warning-icon":"report-modal_warning-icon__p7Sdj"};